import React from 'react';
import { Switch, Tooltip } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setThemeMode, ThemeModeSelector } from '../../../store/themeMode';
import { Mode } from '../../../constants/enums';

import useStyles from './styles';
import { tt } from '@i18n/tt';

const ThemeSwitch: React.FC = () => {
  const dispatch = useAppDispatch();
  const themeMode = useAppSelector(ThemeModeSelector);
  const classes = useStyles();

  return (
    <div className={classes.themeSwitch}>
      <Tooltip title={tt(themeMode === Mode.Light ? 'theme.light' : 'theme.dark')}>
        <Switch
          checked={themeMode === Mode.Dark}
          onChange={(_, checked) => {
            dispatch(setThemeMode(checked ? Mode.Dark : Mode.Light));
          }}
        />
      </Tooltip>
    </div>
  );
};

export default ThemeSwitch;
